document.addEventListener('DOMContentLoaded', function () {
  const calculateButton = document.getElementById('frenet-calculate-button');
  const cepInput = document.getElementById('frenet-cep');
  const resultsDiv = document.getElementById('frenet-results');
  const errorDiv = document.getElementById('frenet-error');
  const productForm = document.querySelector('form[action="/cart/add"]');

  // ============== IMPORTANTE: COLOQUE A URL DO SEU PROXY AQUI ==============
  const PROXY_URL = 'https://sua-url-de-proxy.com/api/frenet'; // Você obterá essa URL na Parte 2
  // =======================================================================

  if (!calculateButton || !cepInput || !resultsDiv || !errorDiv) {
    console.error("ERRO: Elementos do calculador de frete não encontrados.");
    return;
  }

  // Máscara para o CEP
  cepInput.addEventListener('input', function (e) {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 5) {
      value = value.substring(0, 5) + '-' + value.substring(5, 8);
    }
    e.target.value = value.substring(0, 9);
  });

  calculateButton.addEventListener('click', async function () {
    const cep = cepInput.value.replace(/\D/g, '');
    resultsDiv.innerHTML = '<span class="loading-animation">Calculando...</span>'; // Feedback visual
    errorDiv.style.display = 'none';

    if (cep.length !== 8) {
      errorDiv.textContent = 'Por favor, digite um CEP válido (8 dígitos).';
      errorDiv.style.display = 'block';
      resultsDiv.innerHTML = '';
      return;
    }

    // Pega os dados do produto da página
    const variantInput = productForm.querySelector('[name="id"]');
    if (!variantInput) {
      errorDiv.textContent = 'Erro: Não foi possível encontrar a variante do produto.';
      errorDiv.style.display = 'block';
      resultsDiv.innerHTML = '';
      return;
    }
    
    const selectedVariantId = variantInput.value;
    let productData = {};

    // Tenta obter os dados do produto a partir do objeto global do Shopify
    if (window.productJson && window.productJson.variants) {
        const variant = window.productJson.variants.find(v => v.id == selectedVariantId);
        if (variant) {
            productData = {
                weight: (variant.weight / 1000).toString(), // Convertendo gramas para kg
                price: (variant.price / 100).toString(),
                // Adicione dimensões se estiverem disponíveis no seu JSON de produto
                width: variant.width || 5,
                height: variant.height || 5,
                length: variant.length || 5,
                quantity: 1
            };
        }
    }
    
    if (!productData.price) {
        // Fallback se não encontrar os dados
        console.warn('Dados da variante não encontrados. Usando valores padrão.');
        productData = { weight: '0.1', price: '1.00', width: 5, height: 5, length: 5, quantity: 1 };
    }


    try {
      const response = await fetch(PROXY_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          recipientCEP: cep,
          productData: productData
        })
      });

      const data = await response.json();
      resultsDiv.innerHTML = ''; // Limpa o "Calculando..."

      if (!response.ok || !data.ShippingServicesArray || data.ShippingServicesArray.length === 0) {
        throw new Error(data.Message || 'Nenhuma opção de frete encontrada.');
      }
      
      resultsDiv.innerHTML = '<strong>Opções de Frete:</strong>';
      data.ShippingServicesArray.forEach(service => {
        if (service.ShippingPrice > 0 && service.ServiceDescription) {
          resultsDiv.innerHTML += `
            <div class="frenet-result-item">
              ${service.ServiceDescription}: <strong>R$ ${service.ShippingPrice.toFixed(2).replace('.', ',')}</strong>
              (Prazo: ${service.DeliveryTime} dia(s) úteis)
            </div>
          `;
        }
      });

    } catch (error) {
      resultsDiv.innerHTML = '';
      errorDiv.textContent = error.message || 'Erro de comunicação. Tente novamente.';
      errorDiv.style.display = 'block';
      console.error('Erro ao chamar o proxy:', error);
    }
  });
});